// Bret Johnson Orthodontics (Spokane WA) - single office.
// Backend: bondLocations.ts JOHNSON_SPOKANE (brandId "johnson", catalog 6ae05d26,
// Edge loc 4, procedure 30, DB 359). Native booking via ortho2-newpatient backend
// (WCF intake disabled - login not provisioned on DB 359). English-only.
import type { BrandConfig } from "./types";

export const johnson: BrandConfig = {
  slug: "johnson",
  brandId: "johnson",
  brandName: "Bret Johnson Orthodontics",
  logo: "https://drbretortho.com/wp-content/uploads/2024/04/logo.png",
  phone: "(509) 466-2666",
  phoneHref: "tel:+15094662666",
  theme: { primary: "#C0D642", primaryDark: "#074F59" }, // scoured 2026-07-14 drbretortho.com (lime + dark teal)
  locales: ["en"],
  locations: {
    JOHNSON_SPOKANE: {
      id: "JOHNSON_SPOKANE",
      name: "Spokane",
      addressLines: ["10306 N. Nevada St.", "Spokane, WA 99218"],
      mapsUrl: "https://maps.google.com/?q=10306+N+Nevada+St+Spokane+WA+99218",
      timezone: "America/Los_Angeles",
    },
  },
  locationAliases: { SPOKANE: "JOHNSON_SPOKANE", JOHNSON: "JOHNSON_SPOKANE" },
};
